<template>
  <div class='building'>
    <div class='hd ly-card'>
      <div class='fl'>
        <el-button @click='openDigFrom(true)' type='primary' v-if="hasPermission('class_room_create')">新增</el-button>
        <el-button type='primary' @click='exportExcel'>导出</el-button>
        <el-dropdown style='margin-left: 10px' @command='exportSchedule'>
          <el-button type='primary'>
            导出课程表<i class='el-icon-arrow-down el-icon--right'></i>
          </el-button>
          <el-dropdown-menu slot='dropdown'>
            <el-dropdown-item :command='1'>批量导出课程表</el-dropdown-item>
            <el-dropdown-item :command='2'>导出全部课程表</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class='fr'>
        <el-select class='m-l-20' clearable v-model='searchFormData.activate_status' placeholder='是否启用'>
          <el-option label='已启用' :value='true'></el-option>
          <el-option label='已禁用' :value='false'></el-option>
        </el-select>
        <el-date-picker
          v-model='searchFormData.date'
          type='daterange'
          unlink-panels
          range-separator='至'
          start-placeholder='上课开始日期'
          end-placeholder='上课结束日期'
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
          :picker-options='pickerOptions'
        ></el-date-picker>
        <el-select class='m-l-20' clearable v-model='searchFormData.has_course' placeholder='是否有课'>
          <el-option label='全部' :value='-1'></el-option>
          <el-option label='是' :value='true'></el-option>
          <el-option label='否' :value='false'></el-option>
        </el-select>
        <el-input
          v-model.trim='searchFormData.name'
          placeholder='教室名称'
          @keypress.enter.native='search'
        ></el-input>
        <el-button @click='search' type='primary'>查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData='getTableData'
      :tableHeader='tableHeader'
      :searchFormData='searchFormData'
      :statusAction='statusAction'
      :tableConfig='tableConfig'
      class='ly-card'
      ref='lyTable'
    >
      <template v-slot:use='row'>
        <el-button @click='showRow(row)' type='text' size='mini'>查看</el-button>
      </template>
      <template v-slot:action='row'>
        <el-button @click='editRow(row)' type='primary' v-if="hasPermission('class_room_edit')" size='mini'>修改</el-button>
        <el-button v-if="hasPermission('class_room_delete')" @click='delRow(row)' type='danger' size='mini'>删除</el-button>
        <p v-if="!hasPermission('class_room_delete')&&!hasPermission('class_room_edit')">一</p>
      </template>
    </ly-table>
    <el-dialog
      :title="`${defaultFormItem.id ? '修改' : '新增'}教室`"
      :visible.sync='dialogVisible'
      width='800px'
      @opened='openEvent'
    >
      <ly-form
        :defaultFormItem='defaultFormItem'
        :formConfig='formConfig'
        :formKeys='formKeys'
        class='room-form'
        ref='lyForm'
      >
        <template v-slot:picture_url='{item, formData}'>
          <img :src='`${baseUrl}/${formData.picture_url}`' v-if='formData.picture_url' width='200px' />
          <upload
            @successCBK="(value) => mediaChange('picture_url', value, formData)"
            accept='.jpg, .jpeg, .png, .gif, .bmp'
          />
        </template>
      </ly-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='dialogVisible = false'>取 消</el-button>
        <el-button type='primary' @click='addRoom'>确 定</el-button>
      </span>
    </el-dialog>
    <use-detail ref='useDetail' :curRow='curRow'></use-detail>
  </div>
</template>

<script>
import { Dialog, Input, DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu } from 'element-ui';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import { roomTable } from '@/utils/tableHeader';
import { roomFormItem } from '@/utils/formConfig';
import { base } from '@/api';
import utils from '@/utils/utils';
import perMixin from '@/utils/perMixin';
import Upload from '@/components/Upload';
import dayjs from 'dayjs';
import UseDetail from './useDetail';

export default {
  name: 'Room',
  mixins: [perMixin],
  components: {
    LyTable,
    LyForm,
    ElInput: Input,
    ElDialog: Dialog,
    UseDetail,
    ElDatePicker: DatePicker,
    ElSelect: Select,
    ElOption: Option,
    Upload,
    ElDropdown: Dropdown,
    ElDropdownItem: DropdownItem,
    ElDropdownMenu: DropdownMenu
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '下一周',
            onClick(picker) {
              const today = new Date();
              const nextWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
              const nextWeekMonday = new Date(nextWeek.getFullYear(), nextWeek.getMonth(), nextWeek.getDate() - nextWeek.getDay() + 1);
              const nextWeekSunday = new Date(nextWeekMonday.getFullYear(), nextWeekMonday.getMonth(), nextWeekMonday.getDate() + 6);
              picker.$emit('pick', [nextWeekMonday, nextWeekSunday]);
            }
          }
        ]
      },
      dialogVisible: false,
      formKeys: {},
      defaultFormItem: {},
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      searchFormData: {
        activate_status: undefined,
        date: [],
        has_course: -1,
        name: '',
        page_no: 1,
        page_size: 20
      },
      tableHeader: roomTable,
      getTableData: base.getRoom,
      statusAction: [row => base.activateRoom({ id: row.id }), row => base.deactivateRoom({ id: row.id })],
      curRow: {},
      baseUrl: '',
      selection: [],
      tableConfig: {
        action: {
          'selection-change': selection => {
            this.selection = selection;
          }
        }
      }
    };
  },
  computed: {
    term() {
      return this.$store.state.schoolYear.term;
    },
    year() {
      return this.$store.state.schoolYear.year;
    },
    classType() {
      return this.$store.state.schoolYear.classType;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch('app/getOssUrl').then(url => {
        if (url) this.baseUrl = url;
      });
      this.search();
      base.queryBuilding({}).then(res => {
        if (res && res.data) {
          roomFormItem.building_id.options.select = res.data.list;
          this.formKeys = roomFormItem;
        }
      });
      base.searchSpecial({}).then(res => {
        roomFormItem.specialized_subject_id.options.select = res.data.list;
        this.formKeys = roomFormItem;
      });
    },
    openDigFrom(isAdd) {
      this.dialogVisible = true;
      base.queryBuilding({}).then(res => {
        if (res && res.data) {
          roomFormItem.building_id.options.select = res.data.list;
          this.formKeys = roomFormItem;
        }
      });
      if (isAdd) {
        this.defaultFormItem = {
          has_multimedia_equipment: true
        };
      }
    },
    async addRoom() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        let res = null;
        if (this.defaultFormItem.id) {
          // 修改
          res = await base.controlRoom({
            methold: 'put',
            id: this.defaultFormItem.id,
            params: { ...data, activate_status: this.defaultFormItem.activate_status }
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
        } else {
          // 新增
          res = await base.addRoom({ ...data, activate_status: true });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '新增成功');
        }
        if (res) {
          this.$refs.lyTable.setData();
          this.dialogVisible = false;
        }
      }
    },
    delRow(row) {
      this.$confirm(`确认删除-${row.name}？`)
        .then(() => {
          base
            .controlRoom({
              methold: 'delete',
              id: row.id
            })
            .then(res => {
              this.search();
              this.$store.dispatch('msg/showMsg', res.msg || '删除成功');
            });
        })
        .catch(() => {
        });
    },
    editRow(row) {
      this.defaultFormItem = { ...row };
      this.openDigFrom();
    },
    async showRow(row) {
      this.curRow = { ...row };
      this.$refs.useDetail.open();
    },
    search() {
      if (this.searchFormData.date && this.searchFormData.date.length === 2) {
        this.searchFormData = {
          ...this.searchFormData,
          start_time: this.searchFormData.date[0],
          end_time: this.searchFormData.date[1]
        };
      } else {
        delete this.searchFormData.start_time;
        delete this.searchFormData.end_time;
      }
      this.$refs.lyTable.setData();
    },
    openEvent() {
      this.$refs.lyForm.$refs.lyForm.clearValidate();
    },
    exportExcel() {
      base.exportClassroom({
        params: this.searchFormData
      }).then(data => {
        if (data) utils.downloadData(data, '教室列表');
      });
    },
    mediaChange(key, value, formData) {
      if (value && value.length) {
        // eslint-disable-next-line no-param-reassign
        formData[key] = value[0].url;
      }
    },
    async exportSchedule(type) {
      if (!this.searchFormData.date || this.searchFormData.date.length !== 2) {
        this.$message.error('请选择上课时间');
        return;
      }
      let params = {
        year: this.year,
        term: this.term,
        class_type: this.classType
      };
      if (type === 1) {
        if (!this.selection.length) {
          this.$message.error('请先勾选');
          return;
        }
        params = {
          classroom_ids: this.selection.map(item => item.id)
        };
      } else {
        params = this.searchFormData;
      }
      params = {
        ...params,
        start_time: this.searchFormData.date[0],
        end_time: this.searchFormData.date[1]
      };
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === '') {
          delete params[key];
        }
      });
      const res = await base.getRoomExport(params);
      if (res) {
        if ('classroom_ids' in params) {
          this.selection.forEach(item => {
            this.$refs.lyTable.toggleRowSelection(item, false);
          });
        }
        utils.downloadData(res, `课程表${dayjs(params.start_time).format('YYYY年MM月DD日')}至${dayjs(params.end_time).format('YYYY年MM月DD日')}`);
      }
    }
  }
};
</script>

<style lang='less'>
.building {
  .hd {
    overflow: hidden;

    .el-input {
      width: 200px;
      margin-right: 20px;
    }
  }
}

.room-form {
  .el-input {
    width: 220px;
  }
}
</style>
